import "../Guide.css";
import Stage from "../../stage/Stage";
import omnirib from "../../assets/omnirib.png";

function OmniRib() {
  return (
    <Stage>
      <h1>Omni-Tek Steel-Ribbed Armor</h1>
      <p className="guideText">
        Omni-Tek Steel-Ribbed is SEN/AGI and Omni only.
      </p>
      <img
        src={omnirib}
        alt="Omni-Tek Steel-Ribbed stats"
        className="guidePic"
        style={{ maxHeight: "100rem" }}
      />
      <p className="guideContext">
        QL 200 Omni-Tek Steel-Ribbed modifiers from AO Setups
      </p>
    </Stage>
  );
}

export default OmniRib;
